import { AuthDialog } from "@/components/AuthDialog";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { LogIn } from "lucide-react";
import { useState } from "react";
import { useLocation } from "wouter";

type SignInRequiredProps = {
  title: string;
  description: string;
  backHref: string;
  backLabel: string;
  initiallyOpen?: boolean;
};

export function SignInRequired({
  title,
  description,
  backHref,
  backLabel,
  initiallyOpen = false,
}: SignInRequiredProps) {
  const [, navigate] = useLocation();
  const [authDialogOpen, setAuthDialogOpen] = useState(initiallyOpen);

  return (
    <main className="flex min-h-[70vh] items-center justify-center bg-background px-4 py-8">
      <Card className="w-full max-w-md p-8 text-center">
        <LogIn className="mx-auto mb-4 h-11 w-11 text-primary" />
        <h1 className="text-xl font-bold text-foreground">{title}</h1>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">
          {description}
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button
            type="button"
            onClick={() => setAuthDialogOpen(true)}
            data-testid="button-open-sign-in"
          >
            로그인하고 계속
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => navigate(backHref)}
            data-testid="button-back-from-sign-in"
          >
            {backLabel}
          </Button>
        </div>
      </Card>
      <AuthDialog open={authDialogOpen} onOpenChange={setAuthDialogOpen} />
    </main>
  );
}
